module.exports = __webpack_public_path__ + "img/lg_ring_r_c_null_null@2x.d925b034.png";